import React from 'react';
import { useDispatch, useSelector } from '@ecommerce/nest-ssr/common';
import SkpSelect from 'atomic/form/select';
import { SORT_OPTIONS } from 'modules/product/views/components/product-offers-header/data/sort-options.data';
import { OffersState, SortType } from '../../../../../../../../reducers/offers';
import prepareActionName from '../../../../../../../../reducers/helpers/prepare-action-name';
import { ProductInterface } from 'modules/product/interfaces/product.interface';
import OfferInterface from 'interfaces/offer.interface';
import offersPrepare from 'helpers/offers-prepare';

import './product-offers-sort-desktop.scss';

const ProductOffersSortDesktop: React.FC = () => {
    const dispatch = useDispatch();
    const selected = useSelector((state: { offers: OffersState; }) => state.offers.activeSort);
    const offers = useSelector<{ product: ProductInterface; }, OfferInterface[]>(state => offersPrepare(state.product.offers.items));

    const sortProducts = (event: any): void => {
        dispatch({
            type: prepareActionName(`OFFERS_SORT_${event.toUpperCase()}`) as unknown as SortType,
            payload: { activeSort: event, replaceState: true, items: offers }
        });
    };

    return (
        <div className="product-offers-sort">
            <SkpSelect
                hideSelectedOptions={false}
                name="sort"
                label={<label htmlFor="sort-offers">Sortuj:</label>}
                options={SORT_OPTIONS}
                small={true}
                className="product-sort"
                viewType="transparent"
                value={selected.toString()}
                onChange={sortProducts}
                inputId={'sort-offers'}
            />
        </div>
    );
};

export default ProductOffersSortDesktop;
